module.exports = __webpack_public_path__ + "img/ranking_1.a9962c4e.png";